<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <h2 class="el_h2">基础信息</h2>
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="80px"
        class="search_form"
        >
          <el-form-item label="客户" prop="customerKey">
            <el-input placeholder="请输入客户" v-model="search_form.customerKey"></el-input>
          </el-form-item>
          <el-form-item label="隶属单位" prop="rOwnerKey">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.rOwnerKey"
            placeholder="请选择隶属单位"
            clearable
            >
              <el-option
              v-for="item in rOwner_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型" prop="customerTypeKey">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.customerTypeKey"
            placeholder="请选择客户类型"
            clearable
            >
              <el-option label="供应商" value="VE"></el-option>
              <el-option label="收货人" value="CO"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="激活" prop="activeFlagKey">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.activeFlagKey"
            placeholder="请选择激活状态"
            clearable
            >
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
            @click="search_client"
            v-if="btn_permission.includes('wms:basCustomer')||btn_permission.includes('superAdmin')"
            type="primary">查询</el-button>
            <el-button
            v-if="btn_permission.includes('wms:basCustomer')||btn_permission.includes('superAdmin')"
            @click="reset_client">重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 客户档案列表 -->
        <el-table
        v-loading="list_loading"
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        @row-dblclick="check_detail"
        >
          <el-table-column
          align="center"
          type="index"
          label="No"></el-table-column>
          <el-table-column
          align="center"
          sortable
          show-overflow-tooltip
          prop="customerId"
          label="客户"
          ></el-table-column>
          <el-table-column
          align="center"
          label="类型"
          >
            <template slot-scope="scope">
              <span>{{scope.row.customerType=='CO'?'收货人':'供应商'}}</span>
            </template>
          </el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          prop="descrC"
          label="中文名称"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="descrE"
          label="英文名称"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="stop"
          label="站点"
          ></el-table-column>
          <el-table-column
          align="center"
          label="激活"
          >
            <template slot-scope="scope">
              <span>{{scope.row.activeFlag=='Y'?'是':'否'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 客户档案列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="client_size_change"
        @current-change="client_current_change"
        :current-page="client_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="client_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="client_total"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="three"
      >
        <el-row class="el_details_row">
          <!-- 明细客户档案列表 -->
          <el-table
          :data="list_data"
          highlight-current-row
          @row-dblclick="db_details"
          class="details_table"
          ref="details_table"
          border
          max-height="600"
          >
            <el-table-column
            align="center"
            type="index"
            label="No"
            ></el-table-column>
            <el-table-column
            align="center"
            label="客户"
            show-overflow-tooltip
            prop="customerId"
            ></el-table-column>
            <el-table-column
            align="center"
            label="类型"
            >
              <template slot-scope="scope">
                <span>{{scope.row.customerType=='CO'?'收货人':'供应商'}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="details_tabs">
            <!-- 明细表单 -->
            <el-form
            ref="details_form"
            :model="details_form"
            label-width="80px"
            class="details_form"
            :rules="details_rules"
            >
              <el-divider content-position="left">客户信息</el-divider>
              <el-form-item label="客户" prop="customerId">
                <el-input :disabled="customerId_status" v-model="details_form.customerId"></el-input>
              </el-form-item>
              <el-form-item label="客户类型" prop="customerType">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="details_form.customerType"
                placeholder="请选择客户类型"
                :disabled="customerType_status"
                >
                  <el-option label="供应商" value="VE"></el-option>
                  <el-option label="收货人" value="CO"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="隶属单位" prop="rowner">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="details_form.rowner"
                placeholder="请选择隶属单位"
                :disabled="rOwner_status"
                >
                  <el-option
                  v-for="item in user_owner"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="激活" prop="activeFlag">
                <el-switch
                v-model="details_form.activeFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :disabled="activeFlag_status"
                ></el-switch>
              </el-form-item>
              <el-divider content-position="left">基础信息</el-divider>
              <el-form-item label="中文名称" prop="descrC">
                <el-input placeholder="中文名称" @input="" v-model="details_form.descrC"></el-input>
              </el-form-item>
              <el-form-item label="英文名称" prop="descrE">
                <el-input placeholder="英文名称" @input="" v-model="details_form.descrE"></el-input>
              </el-form-item>
              <el-form-item label="站点" prop="stop">
                <el-input placeholder="站点" @input="" v-model="details_form.stop"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                size="mini"
                icon="el-icon-circle-plus-outline"
                :disabled="details_add"
                @click="client_add"
                class="operate_btn"
                v-if="btn_permission.includes('wms:basCustomer:add')||btn_permission.includes('superAdmin')"
                type="primary">增加</el-button>
                <el-button
                size="mini"
                :disabled="details_delete"
                @click="client_delete"
                class="operate_btn"
                type="danger"
                v-if="btn_permission.includes('wms:basCustomer:del')||btn_permission.includes('superAdmin')"
                icon="el-icon-document-delete">删除</el-button>
                <el-button
                size="mini"
                :disabled="details_change"
                @click="client_change"
                class="operate_btn"
                type="primary"
                v-if="btn_permission.includes('wms:basCustomer:edit')||btn_permission.includes('superAdmin')"
                icon="el-icon-edit">修改</el-button>
                <el-button
                size="mini"
                icon="el-icon-circle-check"
                :disabled="details_save"
                @click="client_save"
                class="operate_btn"
                type="primary">保存</el-button>
                <el-button
                size="mini"
                icon="el-icon-circle-close"
                @click="client_cancel"
                class="operate_btn"
                :disabled="details_cancel">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //标签页切换
        activeName:'one',
        //隶属单位
        rOwner_list:[],
        //用户隶属单位
        user_owner:[],
        //客户档案查询表单
        search_form:{
          customerKey:'',
          customerTypeKey:'',
          activeFlagKey:'',
          rOwnerKey:''
        },
        list_data:[],
        //客户档案懒加载
        list_loading:false,
        //客户档案列表分页
        client_current_page:1,
        client_page_size:10,
        client_total:0,
        //明细表单
        details_form:{
          customerId:'',
          customerType:'',
          rowner:'',
          activeFlag:'',
          descrC:'',
          descrE:'',
          stop:''
        },
        //明细表单正则
        details_rules:{},
        //明细表单新增正则
        details_rules_add:{
          customerId:[
            {required:true,message:'请输入客户ID',trigger:'blur'}
          ],
          customerType:[
            {required:true,message:'请选择客户类型',trigger:'change'}
          ],
          rowner:[
            {required:true,message:'请选择隶属单位',trigger:'change'}
          ],
          descrC:[
            {required:true,message:'请输入中文名称',trigger:'blur'}
          ],
          descrE:[
            {required:true,message:'请输入英文名称',trigger:'blur'}
          ],
          stop:[
            {required:true,message:'请输入站点',trigger:'blur'}
          ]
        },
        //明细表单修改正则
        details_rules_edit:{
          descrC:[
            {required:true,message:'请输入中文名称',trigger:'blur'}
          ],
          descrE:[
            {required:true,message:'请输入英文名称',trigger:'blur'}
          ],
          stop:[
            {required:true,message:'请输入站点',trigger:'blur'}
          ]
        },
        //明细当前行数据
        row_details_now:[],
        //明细表单禁用状态
        customerId_status:true,
        customerType_status:true,
        rOwner_status:true,
        activeFlag_status:true,
        details_add:false,
        details_delete:false,
        details_change:false,
        details_save:true,
        details_cancel:true,
        //新增或修改客户判断条件
        client_add_edit:''
      }
    },
    //注册组件
    components:{

    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //隶属单位下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/customer'
      }).then(data=>{
        if(data.data.success==true){
          that.rOwner_list=data.data.data
          that.user_owner=data.data.data
        }else{
          that.$message.warning(data.data.message)
        }
      })
    },
    mounted() {

    },
    methods:{
      //查询客户档案列表
      search_client(){
        this.client_current_page=1
        this.client_page_size=10
        this.activeName='two'
        //获取客户档案列表
        this.get_client_list()
      },
      //重置客户档案查询表单
      reset_client(){
        this.$refs.search_form.resetFields()
        this.client_current_page=1
        this.client_page_size=10
        //获取客户档案列表
        this.get_client_list()
      },
      //客户档案列表分页
      client_size_change(val){
        this.client_page_size=val
        //获取客户档案列表
        this.get_client_list()
      },
      client_current_change(val){
        this.client_current_page=val
        //获取客户档案列表
        this.get_client_list()
      },
      //获取客户档案列表
      get_client_list(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/customer/list',
          params:{
            page:that.client_current_page,
            limit:that.client_page_size,
            customerKey:that.search_form.customerKey,
            activeFlagKey:that.search_form.activeFlagKey,
            customerTypeKey:that.search_form.customerTypeKey,
            rOwnerKey:that.search_form.rOwnerKey
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.client_total=data.data.data.total
            if(that.client_add_edit=='edit'){
              that.list_data.forEach(item=>{
                if(item.customerId==that.row_details_now.customerId&&item.customerType==that.row_details_now.customerType){
                  that.row_details_now=item
                }
              })
              that.db_details(that.row_details_now)
            }else{
              that.db_details(that.list_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //列表行双击事件
      check_detail(row,column,event){
        this.activeName="three"
        //明细行双击事件
        this.db_details(row,column,event)
      },
      //明细行双击事件
      db_details(row,column,event){
        this.client_add_edit=''
        this.details_rules={}
        //明细表单禁用状态
        this.customerId_status=true
        this.customerType_status=true
        this.rOwner_status=true
        this.details_add=false
        this.details_delete=false
        this.details_change=false
        this.details_save=true
        this.details_cancel=true
        this.$refs.details_table.setCurrentRow(row)
        //重置明细表单校验
        this.$refs.details_form.clearValidate()
        //获取明细当前行数据
        this.row_details_now=row
        if(row==undefined){
          return false
        }
        //表单回显
        //客户信息
        this.details_form={
          customerId:row.customerId,
          customerType:row.customerType,
          rowner:row.rowner,
          activeFlag:row.activeFlag=='Y'?true:false,
          descrC:row.descrC,
          descrE:row.descrE,
          stop:row.stop
        }
      },
      //新增客户前置
      client_add(){
        //明细表单禁用状态
        this.customerId_status=false
        this.customerType_status=false
        this.rOwner_status=false
        this.details_add=true
        this.details_delete=true
        this.details_change=true
        this.details_save=false
        this.details_cancel=false
        this.client_add_edit='add'
        //明细表单新增正则
        this.details_rules=this.details_rules_add
        //重置明细表单
        this.$refs.details_form.resetFields()
      },
      //修改客户前置
      client_change(){
        //明细表单禁用状态
        this.customerId_status=true
        this.customerType_status=true
        this.rOwner_status=true
        this.details_add=true
        this.details_delete=true
        this.details_change=true
        this.details_save=false
        this.details_cancel=false
        this.client_add_edit='edit'
        //明细表单修改正则
        this.details_rules=this.details_rules_edit
        //重置明细表单校验
        this.$refs.details_form.clearValidate()
      },
      //新增或修改客户保存
      client_save(){
        let that=this
        that.$refs.details_form.validate((valid)=>{
          if(valid){
            if(that.client_add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/wms/customer',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  customerId:that.details_form.customerId,
                  customerType:that.details_form.customerType,
                  rowner:that.details_form.rowner,
                  descrC:that.details_form.descrC,
                  descrE:that.details_form.descrE,
                  stop:that.details_form.stop
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取客户档案列表
                  that.get_client_list()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.client_add_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/wms/customer/'+that.row_details_now.customerId+'/'+that.row_details_now.customerType,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  descrC:that.details_form.descrC,
                  descrE:that.details_form.descrE,
                  stop:that.details_form.stop
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取客户档案列表
                  that.get_client_list()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除客户
      client_delete(){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/wms/customer/'+that.row_details_now.customerId+'/'+that.row_details_now.customerType
          }).then(data=>{
            if(data.data.success==true){
              //获取客户档案列表
              that.get_client_list()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //取消
      client_cancel(){
        //明细行双击事件
        this.db_details(this.row_details_now)
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .search_form .el-form-item{
    width: 49%;
    margin-bottom: 30px;
    display: inline-block;
  }
  @media screen and (max-width:720px) {
    .search_form .el-form-item{
      width: 100%;
    }
  }
  /* 明细 */
  .operate_btn{
    margin-right: 0px;
  }
  .operate_btn+.operate_btn{
    margin-left: 0px;
  }
  .el_details_row{
    display: flex;
    justify-content: space-between;
  }
  .details_table{
    width: 38%;
  }
  .details_tabs{
    width: 58%;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/record/client.vue